import * as React from 'react';

import { DEFAULT_ROLE_COLOR, ROLE_COLORS } from '../../../constants/role-colors';
import { BADGE_BACKGROUND_ALPHA, BADGE_BORDER_ALPHA, hexToRgba } from '../../../lib/color';
import { Badge } from '../../ui/badge';

export interface RoleBadgeProps {
  /** The translated label to display inside the badge */
  label: string;
  /** The role key (e.g., 'TENANT_ADMIN') used to look up the color */
  roleKey: string;
}

export function RoleBadge({ label, roleKey }: RoleBadgeProps): React.JSX.Element {
  const color = ROLE_COLORS[roleKey] ?? DEFAULT_ROLE_COLOR;

  return (
    <Badge
      className="rounded-full text-xs font-semibold"
      style={{
        backgroundColor: hexToRgba(color, BADGE_BACKGROUND_ALPHA),
        borderColor: hexToRgba(color, BADGE_BORDER_ALPHA),
        color,
      }}
    >
      {label}
    </Badge>
  );
}
